import _ from 'lodash'

function printString (v) {
  return v
}

function printNull () {
  return null
}

function printBoolean (v) {
  return v ? 'Yes' : 'No'
}

function printCoding (v) {
  return v.display || v.code
}

function renderCodeableConcept (cc) {
  const SYSTEM_URL_TO_STRING = {
    'http://www.nlm.nih.gov/research/umls/rxnorm': 'RxNorm',
    'http://hl7.org/fhir/v3/MaritalStatus': 'FHIR MaritalStatus',
    'http://hl7.org/fhir/v3/Race': 'FHIR Race',
    'http://hl7.org/fhir/v3/Ethnicity': 'FHIR Ethnicity',
    'http://hl7.org/fhir/v3/EducationLevel': 'FHIR Education',
    'http://hl7.org/fhir/StructureDefinition/patient-adoptionInfo':
      'FHIR AdoptionInfo',
    'http://hl7.org/fhir/ValueSet/anzsco-occupations': 'ANZSCO Occupations',
    'http://hl7.org/fhir/v3/LivingArrangement': 'FHIR Living Arrangement',
    'urn:ietf:bcp:47': 'IETF'
  }

  let codings

  if (_.get(cc, 'coding')) {
    codings = cc.coding.map((c, i) => {
      const display = c.display || c.code
      return (
        <span
          className='coding'
          key={i}
        >
          <span className='coding-display'>{display}</span>
          <span className='coding-code'>
            {SYSTEM_URL_TO_STRING[c.system]}
            :
            {c.code}
          </span>
        </span>
      )
    })
  } else {
    codings = _.get(cc, 'text')
  }

  return <span className='codeable-concept'>{codings}</span>
}

function renderHumanName (n) {
  const name = _.head(n) || n
  const first = _.head(_.get(name, 'given'))
  const middle = _.chain(name).get('given').tail().head()
    .value()
  const last = _.get(name, 'family')
  const suffix = _.get(name, 'suffix')
  const fullname = [].concat(first, middle, last, suffix)
  const filtered = fullname.filter(na => !_.isNil(na)).join(' ')
  return <span className='human-name'>{filtered}</span>
}

function renderAddress (a) {
  const address = a
  const lines = _.chain(address).get('line').join(', ').value()
  const city = _.get(address, 'city')
  const state = _.get(address, 'state')
  const district = _.get(address, 'district')
  const country = _.get(address, 'country')
  const zip = _.get(address, 'postalCode')
  const cityLine = []
    .concat(city, state, country, zip, district)
    .filter(item => !_.isNil(item))

  return (
    <span className='address'>
      <span className='lines'>{lines}</span>
      <br />
      <span className='city-line'>{`${cityLine.join()}`}</span>
    </span>
  )
}

function renderContactPoint (c) {
  return (
    <span className='contact-point'>
      <span className='contact-point-value'>{_.get(c, 'value')}</span>
      <span className='contact-point-use'>{_.get(c, 'use')}</span>
    </span>
  )
}

function renderValue (value, type) {
  if (_.isNil(value)) {
    return printNull()
  }
  switch (type) {
    case 'string':
      return printString(value)
    case 'integer':
      return printString(value)
    case 'decimal':
      return printString(value)
    case 'boolean':
      return printBoolean(value)
    case 'coding':
      return printCoding(value)
    case 'CodeableConcept':
      return renderCodeableConcept(value)
    case 'ContactPoint':
      return renderContactPoint(value)
    case 'HumanName':
      return renderHumanName(value)
    case 'Address':
      return renderAddress(value)
    default:
      return JSON.stringify(value)
  }
}

export default function ValueRenderer ({ className, type, value }) {
  return (
    <div className={`value ${type} ${className || ''}`}>
      {renderValue(value, type)}
    </div>
  )
}
